import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, DatePicker, Switch, Tooltip, message, Popover, Select } from 'antd';
import { VirtualAccount } from '../../../../models';
import { handleApiExceptions, alertify, beneficiaryNameRegex } from '../../../../app_methods';
import { connect } from 'react-redux';
import Remitters from './remitters';
import _last from 'lodash/last'
import _isEqual from 'lodash/isEqual';
import moment from 'moment';
import { Text4 } from '../../../../styles';


let VirtualAccountForm = (props) => {

    const { form, virtualAccount } = props;
    const { getFieldDecorator } = form;
    const validations = VirtualAccount.validations;
    const masterVirtualAccount = props.current_user.smart_collect_virtual_account || {};
    const scvaSetting = props.current_user?.smart_collect_virtual_account_settings || {};

    const [remitters, setRemitters] = React.useState(virtualAccount.authorized_remitters || []);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);

    const PROVIDER_ADD_ONS_BEFORE = {
        YESBANK: "",
        KOTAK: masterVirtualAccount?.kotak_upi_prefix
    }

    const generateUniqueRequestNumber = () => {
        setIsGenerating(true);
        VirtualAccount.generate_cva_urn().then(response => {
            if (response.success) form.setFieldsValue({ 'unique_request_number': response.data.unique_request_number });
            setIsGenerating(false);
        }).catch(error => {
            setIsGenerating(false);
            handleApiExceptions(error);
        })
    };

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            const form_remitters = form.getFieldValue('remitters') || [];
            if (!form_remitters.every(remitter => remitter.account_number && remitter.account_ifsc)) {
                message.warning("Source account details are not filled.")
                return;
            }
            if (!form_remitters.every(remitter => remitter.account_number.match(/^[A-Za-z0-9]+$/) && remitter.account_ifsc.length == 11)) {
                message.warning("Source account number or ifsc code is invalid.")
                return;
            }
            const trimmed_label = values.label?.trim()
            props.onSubmit({ ...values, label: trimmed_label });
        });
    };
    const addRemitter = () => {
        const form_remitters = form.getFieldValue('remitters') || [];
        if (remitters.length >= 3) {
            message.warning("You can add upto 3 source accounts only");
            return
        }
        if (form_remitters.constructor.name == 'Object' && remitters.length == 0) {
            const remit = remitters;
            remit.push({ account_number: "", account_ifsc: "" })
            setRemitters([...remit]);
            return
        }
        else if (form_remitters.constructor.name == 'Object' && remitters.length != 0) {
            message.warning("Previous source account details are not filled.")
            return
        }
        if (!form_remitters.every(remitter => remitter.account_number && remitter.account_ifsc)) {
            message.warning("Previous source account details are not filled.")
            return;
        }
        else if (!form_remitters.every(remitter => remitter.account_number && remitter.account_ifsc.length == 11)) {
            message.warning("Previous source account ifsc code is invalid.")
            return;
        }
        const remit = remitters;
        remit.push({ account_number: "", account_ifsc: "" })
        setRemitters([...remit]);
    }

    const removeRemitter = (rowIndex) => {
        const form_remitters = form.getFieldValue('remitters') || []
        if (form_remitters.constructor.name != 'Object') {
            const obj = form_remitters.splice(rowIndex, 1);
            form.setFieldsValue({ remitters: form_remitters })
        }
        const remit = remitters;
        remit.splice(rowIndex, 1)
        setRemitters([...remit]);
    }

    const renderLabel = () => {
        return (
            <div className="d-inline">
                <span className="mr-1">Label:</span>
                <Popover
                    content="Nickname for the account to identify later."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover>
            </div>
        )
    };
    const renderURNExtra = () => {
        return (
            <Tooltip title="Generate Random">
                <Icon type="setting" spin={isGenerating} onClick={generateUniqueRequestNumber} />
            </Tooltip>
        )
    };

    const renderDescription = () => {
        return (
            <div className="d-inline">
                <span className="mr-1">Description:</span>
                <Popover
                    content="Virtual account description."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover>
            </div>
        )
    };

    const renderAutoDeactivate = () => {
        return (
            <div className="d-inline">
                <span className="mr-1">Auto Deactivate Date:</span>
                <Popover
                    content="Set date if you want to deactivate this account automatically."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover>
            </div>
        )
    };

    const renderPhoneNumbers = () => {
        return (
            <div className="d-inline">
                <span className="mr-1">Phone Numbers:</span>
                <Popover
                    content="Transaction credit SMS notifications to be sent to these phone numbers."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover>
            </div>
        )
    };

    const phoneNumberValidator = (rule, values = [], callback) => {
        const mobileRegex = /^[0-9]{10}$/;
        const invalidInputs = values.filter((value) => !value.match(mobileRegex));
        if (invalidInputs.length === 0) {
            callback();
        } else if (invalidInputs.length === 1) {
            callback(invalidInputs.join("") + " is not a valid phone number");
        } else {
            callback(
                invalidInputs.slice(0, -1).join(", ") +
                " and " +
                invalidInputs.slice(-1) +
                " are not valid phone number"
            );
        }
    };

    const validateAmountLimit = (fieldName, comparisonValue) => (rule, value, callback) => {
        if (value === undefined || value === null || value === '') {
            callback();
            return;
        }

        if (!/^(?!0\d)(?:\d+)?(?:\.\d{1,2})?$/.test(value)) {
            callback(`Please enter a valid amount with maximum two digits after decimal point.`);
        }

        const num = parseFloat(value);

        if (fieldName === 'IMPS') {
            if (num >= 1 && num <= 500000) {
                callback();
            } else {
                if (num > 500000) {
                    callback(`IMPS Limit is ₹5 lakhs.`);
                } else {
                    callback(`Minimum amount for IMPS is ₹1.`);
                }
            }
        } else if (fieldName === 'RTGS') {
            if (num >= 200000) {
                callback();
            } else {
                callback(`Minimum amount for RTGS is ₹2 lakhs.`);
            }
        } else if (fieldName === 'UPI') {
            if (num >= 1) {
                callback();
            } else {
                callback(`Minimum amount for UPI is ₹1.`);
            }
        } else if (fieldName === 'NEFT') {
            if (num >= 1) {
                callback();
            } else {
                callback(`Minimum amount for NEFT is ₹1.`);
            }
        } else {
            callback();
        }
    };

    const isVPADisabled =
        !scvaSetting.enable_virtual_upi_handle_creation ||
        (!masterVirtualAccount.vpa_provider_code &&
            (masterVirtualAccount.provider_van_prefix === "EBZ121" ||
                masterVirtualAccount.van_provider_code === "IDFC"));

    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    {getFieldDecorator("id", {
                        initialValue: virtualAccount.id,
                        rules: []
                    })(<Input autoComplete='off' hidden />)}
                    <Form.Item label={renderLabel()} colon={false}>
                        {getFieldDecorator("label", {
                            initialValue: virtualAccount.label,
                            rules: [
                                { required: true, message: "Label is required." },
                                { pattern: beneficiaryNameRegex(), message: "Please enter a valid label name." },
                                { max: 255, message: "Max 255 characters are allowed." }
                            ]
                        })(<Input autoComplete='off' />)}
                    </Form.Item>
                </div>
            </div>
            {!virtualAccount.is_edit ?
                <div className='row'>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <Form.Item label={"Virtual Account Number"}>
                            {getFieldDecorator(`virtual_account_number`, {
                                initialValue: virtualAccount.account_number,
                                rules: [
                                    { pattern: '^[0-9A-Za-z]+$', message: "Please enter a valid account number." },
                                    { min: 8, max: scvaSetting?.van_max_length || 14, message: `Account Number allowed length is minimum 8 & maximum ${scvaSetting.van_max_length || 14}` }
                                ]
                            })(<Input addonBefore={masterVirtualAccount?.provider_van_prefix || '111222'} autoComplete='off' type="text" />)}
                        </Form.Item>
                    </div>
                    {masterVirtualAccount.provider_van_prefix !== 'EBZ121' ? <div className="col-sm-12 col-md-6 col-lg-6">
                        <Form.Item label={"Virtual Payment Address"}>
                            {getFieldDecorator('virtual_payment_address', {
                                initialValue: virtualAccount.upi_handle,
                                rules: [
                                    { pattern: "^[A-Za-z0-9.-]", message: "UPI Handle is invalid." },
                                    { min: masterVirtualAccount?.upi_config?.min || 8, max: masterVirtualAccount?.upi_config?.max || 14, message: `UPI Handle allowed length is minimum ${masterVirtualAccount?.upi_config?.min} & maximum ${masterVirtualAccount?.upi_config?.max}` }
                                ]
                            })(<Input disabled={isVPADisabled} autoComplete='off' addonBefore={masterVirtualAccount?.upi_config?.prefix} addonAfter={masterVirtualAccount?.upi_config?.postfix} type="text" />)}
                        </Form.Item>
                    </div> : null}

                </div>
                : null}

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    {console.log(virtualAccount)}
                    <Form.Item label="Unique Request Number" colon={false}>
                        {getFieldDecorator('unique_request_number', {
                            initialValue: virtualAccount.merchant_request_number,
                            rules: validations.urn
                        })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label={renderAutoDeactivate()} colon={false} className="w-100">
                        {getFieldDecorator('auto_deactivate_at', {
                            initialValue: virtualAccount.auto_deactivate_at ? moment(virtualAccount.auto_deactivate_at, "YYYY-MM-DD") : virtualAccount.auto_deactivate_at,
                        })(
                            <DatePicker
                                className="w-100"
                                format="YYYY-MM-DD"
                                disabledDate={(date) => date.valueOf() < moment().subtract(1, "day")}
                            />
                        )}
                    </Form.Item>
                </div>

            </div>
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label={renderPhoneNumbers()} colon={false}>
                        {getFieldDecorator("phone_numbers", {
                            initialValue: virtualAccount.phone_numbers,
                            rules: [{ validator: phoneNumberValidator }]
                        })(
                            <Select
                                mode="tags"
                                tokenSeparators={[","]}
                            />
                        )}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label={renderDescription()} colon={false}>
                        {getFieldDecorator("description", {
                            initialValue: virtualAccount.description,
                            rules: validations.narration
                        })(<Input.TextArea prefix={<Icon type="edit" />} autoComplete='off' />)}
                    </Form.Item>
                </div>
            </div>
            <Button
                className="pl-0 mb-2"
                type="link"
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
            >
                {showAdvancedOptions ? "Hide Advanced Options" : "Show Advanced Options"}
                <Icon type={showAdvancedOptions ? "down" : "right"} />
            </Button>
            <div style={{
                display: !showAdvancedOptions ? "none" : "",
            }}>
                <Remitters
                    form={form}
                    remitters={remitters}
                    addRemitter={addRemitter}
                    removeRemitter={removeRemitter}
                />

                <div className="mr-1 font-weight-bold mb-2">
                    Transaction Amount Limit:
                </div>

                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <Form.Item label="UPI (min txn. amount)">
                            {getFieldDecorator("upi_transfer_limit", {
                                initialValue: virtualAccount?.transaction_amount_limit?.upi,
                                rules: [{ validator: validateAmountLimit("UPI", 1) }],
                            })(
                                <Input
                                    disabled={
                                        virtualAccount.is_edit
                                            ? !virtualAccount.virtual_upi_handle
                                            : !scvaSetting.enable_virtual_upi_handle_creation
                                    }
                                    autoComplete="off"
                                />
                            )}
                        </Form.Item>
                    </div>

                    <div className="col-sm-12 col-md-6">
                        <Form.Item label="UPI (fixed amount)">
                            {getFieldDecorator("upi_fixed_transfer_limit", {
                                initialValue: virtualAccount?.transaction_amount_limit?.upi_fixed,
                                rules: [{ validator: validateAmountLimit("UPI", 1) }],
                            })(
                                <Input
                                    disabled={
                                        virtualAccount.is_edit
                                            ? !virtualAccount.virtual_upi_handle
                                            : !scvaSetting.enable_virtual_upi_handle_creation
                                    }
                                    autoComplete="off"
                                />
                            )}
                        </Form.Item>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <Form.Item label="IMPS (max txn. amount)">
                            {getFieldDecorator("imps_transfer_limit", {
                                initialValue: virtualAccount?.transaction_amount_limit?.imps,
                                rules: [{ validator: validateAmountLimit("IMPS", 500000) }],
                            })(<Input autoComplete="off" />)}
                        </Form.Item>
                    </div>

                    <div className="col-sm-12 col-md-4">
                        <Form.Item label="NEFT (max txn. amount)">
                            {getFieldDecorator("neft_transfer_limit", {
                                initialValue: virtualAccount?.transaction_amount_limit?.neft,
                                rules: [
                                    {
                                        pattern: /^(?!0\d)(?:\d+)?(?:\.\d{1,2})?$/,
                                        message:
                                            "Please enter a valid amount with maximum two digits after decimal point.",
                                    },
                                    { validator: validateAmountLimit("NEFT", 1) },
                                ],
                            })(<Input autoComplete="off" />)}
                        </Form.Item>
                    </div>

                    <div className="col-sm-12 col-md-4">
                        <Form.Item label="RTGS (max txn. amount)">
                            {getFieldDecorator("rtgs_transfer_limit", {
                                initialValue: virtualAccount?.transaction_amount_limit?.rtgs,
                                rules: [{ validator: validateAmountLimit("RTGS", 200000) }],
                            })(<Input autoComplete="off" />)}
                        </Form.Item>
                    </div>
                </div>
                <div className="mr-1 font-weight-bold mb-2">User Defined Fields:</div>
                <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4">
                        <Form.Item label="UDF 1">
                            {getFieldDecorator("udf1", {
                                initialValue: virtualAccount?.udf1,
                                rules: validations.udf1
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div>

                    <div className="col-sm-12 col-md-4 col-lg-4">
                        <Form.Item label="UDF 2">
                            {getFieldDecorator("udf2", {
                                initialValue: virtualAccount?.udf2,
                                rules: validations.udf2
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4">
                        <Form.Item label="UDF 3">
                            {getFieldDecorator("udf3", {
                                initialValue: virtualAccount?.udf3,
                                rules: validations.udf3
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4">
                        <Form.Item label="UDF 4">
                            {getFieldDecorator("udf4", {
                                initialValue: virtualAccount?.udf4,
                                rules: validations.udf4
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div>

                    <div className="col-sm-12 col-md-4 col-lg-4">
                        <Form.Item label="UDF 5">
                            {getFieldDecorator("udf5", {
                                initialValue: virtualAccount?.udf5,
                                rules: validations.udf5
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Submit</Button>
            </div>
        </Form >
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

VirtualAccountForm = Form.create()(VirtualAccountForm);

export default connect(mapStateToProps)(VirtualAccountForm);